import md5 from 'md5';

/**
 * 收藏夹
 */

// 原生收藏夹类型
export const nativePoiTypeMap = {
  'attraction': 'A',
  'food': 'F',
  'hotel': 'H',
  'shopping': 'S',
  'airport': 'B',
  'store': 'V',
  'user': 'U',
  'fuel': 'G',
  // 'limo_camp': 'L',
  'entertainment': 'E',
  'onlinemark': 'Z.O',
  'customPoi': 'Z.C',
};

/**
 * poi类型问题
 */

// poiUid前缀字母对应类型
export const poiTypeMap = {
  A: 'attraction',
  C: 'city',
  H: 'hotel',
  P: 'store',
  D: 'store',
  V: 'poi_store',
  U: 'user',
  B: 'airport',
  S: 'shopping',
  F: 'food',
  G: 'fuel',
  E: 'entertainment',
  'Z.O': 'custom_save',
  'Z.C': 'custom_save',
};

// flagMap，poi_list里poi对象对应flag
export const poiFlagMap = {
  A: 'poi',
  P: 'pickup',
  D: 'dropoff',
  H: 'hotel',
};

/**
 * 计算poi唯一id，主要用于收藏夹数据唯一标识
 * 原生latlng用5位算的，php用6位算的，，为了唯一性，最后和php统一用4位算唯一id
 */
export function getPoiUniqueId(poi) {
  let info = poi && poi.info || {};
  let lat = Number(info.lat).toFixed(4);
  let lng = Number(info.lng).toFixed(4);
  let name = String(info.cn_name).substr(0, 191);

  return md5(lat + ',' + lng + ',' + name);
}

export function favoriteFilter(pois) {
  let poi_list = [],
    city_maps = {},
    region_maps = {};

  pois && pois.length && pois.forEach(poiRaw => {
    let poi_uid = '',
      poi_type = poiRaw.poi_type,
      info = poiRaw;

    // 先提取城市
    let city_id = poiRaw.city_id;
    let city = {
      city: city_id,
      poi_uid: 'C.' + city_id,
      lat: poiRaw.lat,
      lng: poiRaw.lng,
      cn_name: poiRaw.city_name || '未知城市',
      en_name: '',
      pic: {},
    };

    // 重复城市做合并处理，以第一个为准
    city_maps[city_id] = {...city, ...city_maps[city_id]};

    // 提取region
    let region_id = poiRaw.region_id;
    let region = {
      region_id,
      region_cn: poiRaw.region_name,
    };
    region_maps[region_id] = {...region, ...region_maps[region_id]};


    let poi = {
      info
    };
    poi.favorites_id = getPoiUniqueId(poi);

    // 补充默认poi_type
    if (!nativePoiTypeMap[poi_type] || !poiRaw.poi_id) {
      poi_type = 'customPoi';
    }
    // 组装poi_uid
    // 自定义类型Z.C.${favorites_id}
    if (poi_type == 'customPoi' || poi_type == 'onlinemark') {
      poi_uid = nativePoiTypeMap[poi_type] + '.' + poi.favorites_id;
    } else {
      poi_uid = nativePoiTypeMap[poi_type] + '.' + poiRaw.poi_id;
    }
    poi.poi_uid = poi_uid;

    // 服了，原生和后端的类型不对应，要修正
    if (poi_type == 'customPoi' || poi_type == 'onlinemark') {
      poi_type = 'custom_save';
    } else if (poi_type == 'store') {
      poi_type = 'poi_store';
    }
    poi.poi_type = poi_type;

    info.region = info.region_id;
    info.city = info.city_id;
    info.pic_thumbnail = info.pic_thumbnail ? 'data:image/jpg;base64,' + info.pic_thumbnail : '';
    info.pic = {
      // full: info.pic_thumbnail,
      // big: info.pic_thumbnail,
      small_s: info.pic_thumbnail,
    };

    delete info.region_id;
    delete info.city_id;
    delete info.pic_thumbnail;

    poi_list.push(poi);
  });

  let result = {
    poi_list,
    city_maps,
    region_maps,
    c_page: 1,
    next_page: ''
  };

  return result;
}

/**
 * 获取poiUid或poi的flag
 */
export function flagOfPoiUid(poiUid) {
  if (typeof poiUid === 'object' && poiUid) {
    poiUid = poiUid.poi_uid || '';
  }
  let index = poiUid.lastIndexOf('.');
  let flag = poiFlagMap[poiUid.substring(0, index)] || 'poi';

  return flag;
}

export function isOldTrip(trip) {
  return trip.old_trip_type === 1 || trip.old_trip_type === 3;
}

/**
 * 返回传入的poiUid或poi对象的poi类型
 */
export function typeOfPoiUid(poiUid) {
  let type;

  if (!poiUid) return;

  if (typeof poiUid === 'object') {
    poiUid = poiUid.poi_uid || '';
  }

  let index = poiUid.lastIndexOf('.');
  type = poiUid.substring(0, index);
  type = poiTypeMap[type];

  return type;
}




// WEBPACK FOOTER //
// ./src/helpers/favorite.js